export const FilterBarDivider = () => (
  <div className={'h-width-full h-border-bottom h-pv-2xs h-bg-white'} />
);
